import { BbIdImplicitFlowAuthService, BbIdPKCEAuthService } from 'auth';
import { environmentVars } from 'constants/services';
import { History } from 'history';
import { LocalDeviceStorageService } from '../device-storage';
import { LaunchDarklyFeatureFlagService } from '../feature-flags/launchdarkly-feature-flag-service';
import { createDIContainerProvider } from './DIContainerProvider';

const appServices: Parameters<typeof createDIContainerProvider>[0] = {
  authService: undefined as any,
  deviceStorageService: new LocalDeviceStorageService(),
  featureFlagService: new LaunchDarklyFeatureFlagService(),
};

export const createAppServices = (history: History): void => {
  if (!appServices.authService) {
    if (environmentVars.USE_REFRESH_TOKENS) {
      appServices.authService = new BbIdPKCEAuthService(
        history,
        appServices.deviceStorageService
      );
    } else {
      appServices.authService = new BbIdImplicitFlowAuthService(
        history,
        appServices.deviceStorageService
      );
    }
  }
};

export const getAppServices = (): typeof appServices => {
  return appServices;
};
